export default __webpack_public_path__ + "dad358a19f9963176cac48e41f568221.png";